import React from 'react';
import { Text, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';

/**
 * React functional component representing the drugs details for the mod flex selection.
 * @returns {React.Component} The rendered drugs details component.
 */
const SpendingAccountDetails = ({ data }) => (
    <div style={{ whiteSpace: 'pre-line' }}>
        {
            data.isPooled &&
                <Text small margin="5px 0px 0px 0px">
                    {
                        `$${ helpers.formatNumber(data.pooledAmountAvailable) } ${ i18n.t(tokens.labels.signup.spendingAccountCombinedMaximum) }`
                    }
                </Text>
        }

        {
            data.includeHsa &&
                <Text small margin="5px 0px 0px 0px">
                    {
                        `$${ helpers.formatNumber(data.hsaAmount) } ${ i18n.t(tokens.labels.signup.spendingAccountHsaMaximum) }`
                    }
                </Text>
        }

        {
            data.includeLsa &&
                <Text small margin="5px 0px 0px 0px">
                    {
                        `$${ helpers.formatNumber(data.lsaAmount) } ${ i18n.t(tokens.labels.signup.spendingAccountLsaMaximum) }`
                    }
                </Text>
        }

        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.monthWaitingPeriod, { eligibilityPeriod: data.eligibilityPeriod }) }</Text>
        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.minimumHoursPerWeekRequired, { minHoursPerWeek: data.minHoursPerWeek }) }</Text>
        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtAge, { terminationAge: data.terminationAge }) }</Text>
    </div>
);

export default SpendingAccountDetails;